import axios from 'axios';
import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import moment from 'moment';
import { connect } from 'react-redux';
import { showBlocker, hideBlocker } from '../../actions/blocker';
import {
    saveMasterData,
    fetchMasterData,
    updateMasterData,
    deleteMasterData
} from '../../actions/master-data';


function CheckApi(props) {
    const [posts, setPosts] = useState([])
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [formLoader, setformLoader] = useState(false)
    const [showAlert, setShowAlert] = useState(false)


    useEffect(() => {
        props.fetchMasterData("WORKALLOCATION",'')
            .then((data, textStatus, jqXHR) => setPosts(data))
            .catch((jqXHR, status, error) => null)
    }, [])
   
    const url ="https://fdportal.spicejet.com/fdportal/Users/WorkAllocation";
    const usernamelog = props.username
    const [data, setData] = useState({
           
             "from":"",
            "To":"",
            "TimingFrom":"",
            "TimimngTo":"",
            "CompleteFolder":"",
            "SingleCFP":"",
            "InternationalFolder":"",
            "userName" : props.username,
            "actype" : ""
    })
  
 const  submit = (e)  => {  
    setformLoader(true);
        fetch(url, {
            method: 'POST',
            headers: {"Content-Type":'application/json', "Accept":'application/json',
            'Authorization': localStorage.getItem('effToken') },
            body: JSON.stringify(data)
    }).then((response) => {
       
        setData({           
            "from":"",
           "To":"",
           "TimingFrom":"",
           "TimimngTo":"",
           "CompleteFolder":"",
           "SingleCFP":"",
           "InternationalFolder":"",
           "userName" : props.username,
           "actype" : ""
   })
    if(response.status == 200){
        alert("Data submited");
    }else{
        
        alert("Not submited, Invalid entry")
    }
    
        setformLoader(false);
        // setShowAlert(true);
        return response.json();
        
    }, (error) => {
        setformLoader(false);
        alert("Not submited, Invalid entry")
    })
    
    }    
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    today = yyyy + '-' + mm + '-' + dd;

    const past_from = moment(today, 'YYYY-MM-DD').subtract(3, 'days').toDate();
    //const past = moment(past_from).format('YYYY-MM-DD')
    const past = moment(today).format('YYYY-MM-DD');
    const future_to = moment(new Date(), 'YYYY-MM-DD').add(3, 'days').toDate();
    const future = moment(future_to).format('YYYY-MM-DD')
    // const pastto = today.getData()

    const  handle = (e, type,selectedOption, id)  =>{      
        const newdata={...data}
        let multiData = ""
        if(type == 'date'){
            
            newdata[e.target.id] = moment(e.target.value).format('YYYY/MM/DD')
            setData(newdata)     
        }
        else if(type == 'SingleCFP' || type == 'CompleteFolder' || type == 'InternationalFolder')
        {
            multiData = e.map(f => f.value).join(",")
        newdata[type] = multiData
        setData(newdata)
        }    
        else if (id == 'actype'){
            newdata.actype = e.target.value
            setData(newdata);
            alert(newdata.actype)
        }
        else{
            newdata[e.target.id] = e.target.value
            setData(newdata)
        }
    }

    const[isDisable, setDisable] = useState(true);
    const[minValue, setMinValue] = useState(today);

    const handleDate = (e) => {
        setDisable(false);
        setMinValue(e.target.value);
    }
    const[toDate, setToDate] = useState();
    const handleToDate = (e) => {
        setToDate(e.target.value);
        // if(minValue == toDate){
        //     if(datevalue == '00:00'){
        //         document.getElementById("timeLimit").innerHTML = "";
        //         document.getElementById("TimimngTo").value = "23:59";
        //     }
        //     else if(fromTime > datevalue){
        //         document.getElementById("timeLimit").innerHTML = "Please Select time greater than from time";
        //         document.getElementById("TimimngTo").value = null;
        //     }
        //     else{
        //         document.getElementById("timeLimit").innerHTML= null;
        //     }
        // }
    }
    const[fromTime, setFromTime] = useState();
    const handleTime = (e) => {
        setFromTime(e.target.value);
        // if(minValue == toDate){
        //     if(datevalue == '00:00'){
        //         document.getElementById("timeLimit").innerHTML = "";
        //         document.getElementById("TimimngTo").value = "23:59";
        //     }
        //     else if(fromTime > datevalue){
        //         document.getElementById("timeLimit").innerHTML = "Please Select time greater than from time";
        //         document.getElementById("TimimngTo").value = null;
        //     }
        //     else{
        //         document.getElementById("timeLimit").innerHTML= null;
        //     }
        // }
    }
    const[ToTime, setToTime] = useState();
    

    const handleTimeValue = (e) => {
        // setData({   
        //    "TimingFrom":"",
        //    "TimimngTo":"",
        // })
    }
    const handleToTimeValue = (e) => {
        // setData({   
        //    "TimingFrom":"",
        //    "TimimngTo":"",
        // })s
        
    }
    const handleTimeLimit = (e) => {
        setToTime(e.target.value);
        let datevalue = document.getElementById("TimimngTo").value;  
        console.log(`${fromTime} and ${datevalue}` )   
           if(minValue == toDate){
                if(datevalue == '00:00'){
                    document.getElementById("timeLimit").innerHTML = "";
                    document.getElementById("TimimngTo").value = "23:59";
                }
                else if(fromTime > datevalue){
                    document.getElementById("timeLimit").innerHTML = "Please Select time greater than from time";
                    document.getElementById("TimimngTo").value = null;
                }
                else{
                    document.getElementById("timeLimit").innerHTML= null;
                }
        }
    }   
    
    const customStyles = {
        control: (base, state) => ({
          ...base,
          background: "#213852",
          // match with the menu
          borderColor: '#fff',
          borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
          // Overwrittes the different states of border
          borderColor: state.isFocused ? "yellow" : "#000",          
          color: state.isFocused ? "yellow" : "#000",
          // Removes weird border around container
          boxShadow: state.isFocused ? null : null,
          "&:hover": {
            // Overwrittes the different states of border
            borderColor: state.isFocused ? "white" : "blue",
             coolor:"#000"
          }
        }),
        menu: base => ({
          ...base,
          borderRadius: 0,
          marginTop: 0,          
          background: "#213852",
          color: "#fff"
        }),
        menuList: (base, state) => ({
          ...base,
          padding: 0,
          background: "white",
          color: 'black',
        }),
        input: base =>({            
          ...base,
          padding: 0,
          background: "#213852",
          color: '#fff'
        })
      }; 
      if(showAlert){
        return (
            <div className='text-center col-md-3' style={{margin: "auto"}}>
                <div className="alert alert-sm alert-success alert-dismissible fade show" role="alert">
                    <strong>Data Submitted successfully</strong>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"
                        onClick={() => { 
        setShowAlert(false); }}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        )
        }
      if(formLoader){

        return (
            <div className=" loader spinner-border text-light"></div> 
        )        
      }
    //   console.log(blocker, "checking blocker")
    return (
        <div>
            <form onSubmit={(e) => submit(e)} name="workAllocation"> 
                <div className="form-row">
                    <div className="form-group col-6">
                    <label className="col-4 col-form-label col-form-label-sm text-left">Aircraft Type</label>
                        <select  className="col-8 col-form-label rounded-0 bg-transparent text-light" required="required" onChange={(e) =>handle(e, 'actype')} id="actype">
                            <option selected disabled="disabled" value="">Aircraft Type</option>
                            <option  id="actype" name="Boeing" value="Boeing" required>Boeing</option>
                            <option id="actype" name="Bombardier" value="Bombardier" required >Bombardier</option>
                        </select>
                    </div>
                    <div className="form-group col-6"></div>
                    <div className="form-group col-6">
                        <label className="col-4 col-form-label col-form-label-sm text-left">From:</label>
                        <input  
                        className="col-8 col-form-label rounded-0 bg-transparent text-light" 
                        required type="date"
                        onChange={(e) => {handleDate(e); handle(e,'date'); handleToTimeValue(e)}}
                        onKeyDown="return false"
                         id="from"                          
                        min={past}
                        max={future}
                        />                                    

                    </div>
                    <div className="form-group col-6">
                        <label className="col-4 col-form-label col-form-label-sm text-left">To:</label>
                        <input name="To"  
                        className="col-8 col-form-label rounded-0 bg-transparent text-light" 
                        required type="date"
                        min={minValue}
                        max={future}
                        disabled={isDisable ? true : false}
                        onChange={(e) =>{handleToDate(e);handle(e,'date'); handleTimeValue(e)}} id ="To"
                        onKeyDown="return false"
                        />    
                    </div>
                    <div className="form-group col-6">
                        <label className="col-4 col-form-label col-form-label-sm text-left">Timing:</label>
                        <input name="time" required  className="col-8 col-form-label rounded-0 bg-transparent text-light" type="time" 
                        onChange={(e) =>{handleTime(e); handle(e) }} id ="TimingFrom" value={data.TimingFrom} 
                         />
                    </div>
                    <div className="form-group col-6">
                        <label className="col-4 col-form-label col-form-label-sm text-left">Timing:</label>
                        <input name="time" required className="col-8 col-form-label rounded-0 bg-transparent text-light" type="time"
                            onChange={(e) =>{handleTimeLimit(e); handle(e)}}
                            id ="TimimngTo" value={data.TimimngTo} 
                            
                        />
                        <p id="timeLimit"></p>
                    </div> 
                    <div className="form-group col-12">
                        <fieldset>
                        <legend>Assign Users:</legend>
                        
                        <div className="form-group col-12">
                            <div className="row">
                                <label  className="col-4 col-form-label col-form-label-sm text-left">Complete Folder</label>
                                <Select
                                    name="CompleteFolder" 
                                    className="col-8 col-form-label rounded-0 bg-transparent text-light" 
                                    isMulti 
                                    id="CompleteFolder"
                                    onChange={(e) =>handle(e, 'CompleteFolder')}
                                    options={posts.map((v,i)=>(
                                        {label:v.UserName,value:v.UserName}
                                    ))}
                                    styles={customStyles}
                                />
                            </div>
                        </div>
                        <div className="form-group col-12">
                            <div className="row">
                                <label className="col-4 col-form-label col-form-label-sm text-left">Single CFP </label>
                                <Select 
                                    name="SingleCFP"
                                    className="col-8 col-form-label rounded-0 bg-transparent text-light"
                                    isMulti 
                                    id="SingleCFP"
                                    onChange={(e) =>handle(e, 'SingleCFP')}
                                    options={posts.map((v,i)=>(
                                        {label:v.UserName,value:v.UserName}
                                    ))}
                                    styles={customStyles}
                                />
                            </div>
                        </div>
                        <div className="form-group col-12">
                            <div className="row">
                                <label className="col-4 col-form-label col-form-label-sm text-left">International Folder </label>
                                <Select 
                                    name="InternationalFolder"
                                    className="col-8 col-form-label rounded-0 bg-transparent text-light"
                                    isMulti 
                                    id="InternationalFolder"
                                    onChange={(e) =>handle(e, 'InternationalFolder')}
                                    options={posts.map((v,i)=>(
                                        {label:v.UserName,value:v.UserName}
                                    ))}
                                    styles={customStyles}
                                />
                            </div>
                        </div>
                        </fieldset>
                    </div>
                    {/* <div className="form-group col-6">
                        <div className="col-7 offset-5 rounded-0 bg-transparent text-light">
                            <p value="completeFolder"
                        name="completeFolder"
                        >Complete Folder</p>  
                        </div>
                    </div> */}
                   
                    {/* <div className="form-group col-6">
                        <div  className="col-7 offset-5 rounded-0 bg-transparent text-light">
                            <p 
                            name="singleCFP">Single CFP </p>
                        </div>
                    </div> */}
                    {/* <div className="form-group col-6">
                        <div  className="col-7 offset-5 col-form-label rounded-0 bg-transparent text-lightrounded-0 bg-transparent text-light">
                            <p value="international"
                            name="international">International Folder </p>
                        </div>
                    </div> */}
                        {/* <div className='form-group col-12 '>
                        <input name="userName" value="userName"
                        />
                    </div> */}
                    <div className="form-group col-2 offset-6">
                        <input type="submit" value="Submit"/>
                    </div>                   
                </div>
            </form>
           
        </div>
    )
}

const mapStateToProps = state => ({ username: state.auth.user.username, blocker: state.blocker });



const mapActionsToProps = {
    showBlocker, hideBlocker,
    saveMasterData, fetchMasterData, updateMasterData, deleteMasterData,
};
export default connect(mapStateToProps, mapActionsToProps)(CheckApi);